import React, { useState } from "react";

function SearchResultsDropdown({ results, onSelect }) {
  return (
    <div style={{ position: "relative" }}>
      <ul
        style={{
          position: "absolute",
          zIndex: 1000,
          backgroundColor: "white",
          listStyleType: "none",
          padding: 0,
          margin: 0,
          border: "1px solid #ddd",
          borderRadius: "4px",
          width: "400px",
          boxShadow: "0 2px 4px rgba(0,0,0,.2)",
          maxHeight: `120px`, // Set maxHeight dynamically
          overflowY: "auto", // Add scrolling
        }}
      >
        {results.map((result) => (
          <li
            key={result.staff_number}
            onClick={() => onSelect(result)}
            style={{
              padding: "10px",
              borderBottom: "1px solid #ddd",
              cursor: "pointer",
            }}
          >
            {`${result.emp_first_name} ${result.emp_last_name} / ${result.staff_number} ${result.manager_name?`/ ${result.manager_name}`:""}`}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default SearchResultsDropdown;
